<template>
	<div>
		<el-card class="box-card" :label="title" shadow="hover" v-for="(item, index) in pageset" :key="index">
			<div slot="header" class="clearfix">
				<span>{{title}}</span>
			</div>
			<div v-for="(i, idx) in item.setlist">
				<div v-if="i.controltype == 'table'">
					<tableui
						ref="cargo"
						editcell="1"
						:tableData="i.cargolist"
						:columns="columns"
						@gridhandle="val => gridhandle(val, i, idx)"
						@autoaddrow="val => gridhandle(val, i, idx)"
						:gridheight="gridheight"
						@setuparrow="setuparrow"
						emptytext="请添加商品"
						@selectFilter="selectFilter"
						@gridchange="gridchange"
					></tableui>
					<el-row v-if="isselcargo">
						<el-col :span="10" style="color:transparent">1</el-col>
						<el-col :span="10">
							 <el-button size="medium" type="primary" round @click="selectcargolist"><i class="el-icon-circle-plus"></i> 从商品库中添加</el-button>
						</el-col>
					</el-row>
				</div>
				<el-form-item
					v-if="
						(i.controltype == 'text' || 'textarea' || 'select' || 'checkbox' || 'combox-checkbox') &&
							i.controltype != 'table' &&
							i.ishidden == 'False'
					"
					:label="i.showname"
					label-width="80px"
					size="mini"
				>
					<el-input
						:ref="i.colname"
						v-model="i.value"
						:type="i.controltype"
						:style="{ width: `${i.coltdwidth}px` }"
						v-if="(i.controltype == 'text' || i.controltype == 'textarea') && i.ishidden == 'False'"
						@keyup.native="val => enterinput(val, i, index)"
					></el-input>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						v-if="i.controltype == 'select' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@keyup.native="val => enterinput(val, i, index)"
					>
						<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
					</el-select>
					<label v-if="i.controltype == 'checkbox' && i.ishidden == 'False'">
						<el-checkbox
							:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
							v-model="i.value"
							:true-label="1"
							:false-label="0"
							:ref="i.colname"
							:checked="i.value"
							@change="val => setcheck(val, i)"
						></el-checkbox>
					</label>
					<div v-if="i.controltype == 'combox-checkbox' && i.ishidden == 'False'">
						<el-checkbox
							:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
							true-label="1"
							false-label="0"
							:ref="i.colname"
							:checked="i.value != '' && i.value != '0.00' ? true : false"
						></el-checkbox>
					</div>
				</el-form-item>
			</div>
		</el-card>
		<selectcargo ref="selectcargo" @addcargorow="addrow" @closecargo="closecargo"></selectcargo>
		<dialogwin ref="dialogwin" @dialogsrue="dialogsrue"></dialogwin>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
import selectcargo from '@/components/baseinfo/selectcargo.vue';
import dialogwin from '@/components/tools/dialogwin.vue';
//import cargolist from '@/pages/baseinfo/cargolist';
export default {
	components: {
		tableui,
		selectcargo,
		dialogwin
		//cargolist
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		l_mode: {
			type: String,
			default: ''
		},
		gridheight: {
			type: String,
			default: '100px'
		},
		isselcargo:{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			//packageindex: 0,
			//orderempty:[{ index: 1,p_pkval:'',cargolist:[],baginfo:{packageweight:1,}}],
			orderinfo: {},
			pageset: [],
			setlist: [],
			columns: [],
			cargorow: {},
			gridrowindex: 0,
			handle: {
				field: '',
				title: '操作',
				type: 'template',
				template: [
					{ type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
					{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
				],
				width: 120,
				sortable: false,
				evttype: 'click',
				colshow: '1',
				event: ''
			},
			handle2: {
				field: '',
				title: '操作',
				type: 'template',
				template: [
					{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
				],
				width: 120,
				sortable: false,
				evttype: 'click',
				colshow: '1',
				event: ''
			},
			iscopy:0,
			//cargoparam:{},
			gridcolindex: -1,
			t_type:'',
			storagehouse:'',
			isdetail:0,
			syscol:'',
			isadd:true,
			supplier:''//供应商
		};
	},
	mounted() {},
	methods: {
		init(param) {
			var that = this;
			this.isdetail=0;
			this.storagehouse='';
			this.supplier='';
			if (param.syscol != undefined) {
				this.syscol = param.syscol;
			}
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			if (param.orderinfo != undefined) this.orderinfo = param.orderinfo;
			if (param.t_type != undefined) this.t_type = param.t_type;
			if (param.isdetail != undefined) this.isdetail = param.isdetail;
			if(param.isadd!=undefined) this.isadd=param.isadd;
			this.setlist = [];
			this.getsetlist();
		},
		getsetlist() {
			var that = this;
			this.$apipost.get.GetPagecolSet({ syscol: this.syscol, l_mode: this.l_mode }).then(res => {
				if (res.length > 0) {
					that.setlist = res;
					if(that.l_mode.indexOf('明细列表')>-1){
						 var columns= JSON.parse(JSON.stringify(res[0].table));
						if(that.isdetail==0){
							if(that.isadd){
								that.handle.index = that.columns.length + 1;
								columns.push(that.handle);
							}
							else{
								that.handle2.index = that.columns.length + 1;
								columns.push(that.handle2);
							}
						}else{
							columns.forEach(e=>{
								e.type='text';
							});
						}
						that.columns=columns;
						that.setcargocol(res[0].table);
						//debugger
						that.setpagelayout();
					}else
						that.getcargosetlist();
				}
			});
		},
		//包裹列表的信息
		getcargosetlist() {
			//debugger
			var that = this;
			this.$apipost.get.GetPagecolSet({ syscol: this.syscol, l_mode: '包裹信息列表-'+this.t_type }).then(res => {
				if (res.length > 0) {
					that.setlist.push(res[0]);
					var columns=JSON.parse(JSON.stringify(res[0].table));
					if(that.isdetail==0){
						if(that.isadd){
							that.handle.index = that.columns.length + 1;
							columns.push(that.handle);
						}
						else{
							that.handle2.index = that.columns.length + 1;
							columns.push(that.handle2);
						}
					}else{
						columns.forEach(e=>{
							e.type='text';
						});
					}
					that.columns =columns;
					that.setcargocol(res[0].table);
					//debugger
					that.setpagelayout();
				}
			});
		},
		//生成默认行
		setcargocol(colset) {
			var cargo = '';
			colset.forEach(e => {
				if (e.type != 'template') {
					cargo += '"' + e.field + '":"",';
				}
			});
			if (cargo != '') {
				cargo = cargo.substring(0, cargo.length - 1);
			}
			cargo = '[{' + cargo + '}]';
			this.cargorow = JSON.parse(cargo)[0];
		},
		//设置页面数据
		setpagelayout() {
			var that = this;
			this.pageset = [];
			this.pageset.push({ setlist: JSON.parse(JSON.stringify(this.setlist)) });
			if (this.orderinfo.list==undefined) {
				this.pageset.forEach(e => {
					e.setlist.forEach(s => {
						if (s.controltype == 'table') {
							s.cargolist = [];
							if(!this.isselcargo)
								s.cargolist.push(JSON.parse(JSON.stringify(that.cargorow)));
						}
					});
				});
			}else{
				var index=0;
				//包裹列表
				this.orderinfo.list.forEach(e=>{
					if(index>0)
						that.pageset.push({ setlist: JSON.parse(JSON.stringify(that.setlist)) });
					that.pageset[index].setlist.forEach(s => {
						if (s.controltype == 'table') {
							s.cargolist = e.cargolist;
							if(s.cargolist.length==0)
							{
								if(!that.isselcargo)
									s.cargolist.push(JSON.parse(JSON.stringify(that.cargorow)));
							}
						}else{
							for(var i in e.baginfo){
								if(s.colname.indexOf(i)>-1){
									s.value=e.baginfo[i];
								}
							}
							for(var i in that.orderinfo){
								if(s.colname.indexOf(i)>-1){
									s.value=that.orderinfo[i];
								}
							}
						}
					});
					index++;
				});
			}
			this.$emit('loadcallback');
		},
		//列表操作列
		gridhandle(e, i, index) {
			var that = this;
			if (e.event == 'addrow'&&that.isadd) {
				that.pageset[0].setlist.forEach(s => {
					if (s.controltype == 'table') {
							if(!that.isselcargo){
								//s.cargolist.splice(index, 0, JSON.parse(JSON.stringify(that.cargorow)));
								s.cargolist.push(JSON.parse(JSON.stringify(that.cargorow)));
								return false;
							}
					}
				});
			}
			if (e.event == 'delrow') {
				this.deleteRow(e, i, index);
			}
			if (e.event == 'getcargo') {
				this.GetCargo(e,i, false); //获取商品基本信息
			}
			if(e.event=='getsuppliercargo'){//读取输入的商品信息中货品编号中供应商的报价记录
				this.GetSupplierCargo(e,i,false);
			}
		},
		GetSupplierCargo(e,i, iscallback){
			var that=this;
			if(this.supplier==''){
			 	this.$tool.message('请选择供应商', 0);
				return false;
			}
			var pkval=e.row[e.field];
			
			if(pkval!=''){
				//按供应商和货品编号，获取对应的报价信息
				this.$apipost.get.CreateGrid({
				l_mode:'货品管理',
				tab:'tab1',
				pageindex:0,
				showcol:'',
				pagesize:200,
				sort:' u_createtime desc ',
				search:" and cno='"+pkval+"'",
				listparam:'',
				iscount:false,
				userid:localStorage.getItem('userid')}).then(res => {
					if(res.data.length==1){
						//查找有效报价
						that.getsupplierprice(res.data);
					}else{
						that.openselectcargo();
					}
				});				
			}
			else
				this.openselectcargo();
		},
		//获取商品勾选行
		GetCargo(e,i, iscallback) {
			//获取商品信息
			var that = this;
			var storehouse=this.storagehouse;
			if(this.$refs.p_bagid!=undefined)
				storehouse=this.$refs.p_bagid[0]._data.selected.currentLabel;
				
			if(storehouse==''){
			 	this.$tool.message('请选择所在仓库', 0);
				return false;
			}
			var rowindex = e.index;
			var colindex = e.colindex;
			this.gridrowindex = rowindex;
			this.gridcolindex = colindex;
			var search = new Object();
			search.storehouse = storehouse;
			//debugger
			if (iscallback) {
				search = JSON.parse(e.search);
			} else {
				var field = e.field;
				search[field] = i.cargolist[rowindex][field];
			}
			var paraminfo = {
				search: JSON.stringify(search),
				pageindex: 0,
				pagesize: 200,
				sort: '',
				tab: 'tab1',
				l_mode: '商品库管理',
				showcol: '',
				userid: localStorage.getItem('userid')
			};
			// console.log('商品',escape(JSON.stringify(paraminfo)));
			// return false;
			this.$tool.loading('正在获取商品', this.divclass);
			this.$apipost.get.GetBaseCargoList({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				//console.log('商品信息',res,);
				if (res.count == 1) {
					that.addcargorow(res.data,i);
				} else {
					if (iscallback) {
						//debugger
						if (res.count > 1)
							//根据返回内容回填到列表
							that.addcargorow(res.data,i,true);
					} else {
						//弹出选择框
						// that.cargoparam = {
						// 	searchlist: search,
						// 	storehouse: storehouse,
						// 	type: 'select'
						// };
						if (that.$refs.selectcargo != undefined) that.$refs.selectcargo.init({searchparam:'1',storehouse:storehouse,type: 'select',searchlist: search});
					}
				}
			});
		
		},
		//确认选择
		surecargo() {
			//debugger
			//debugger;
			if (this.$refs.selectcargo.selectedall) {
				if (this.$refs.selectcargo.cargolist.length > 0)
					this.GetCargo({ search: this.$refs.selectcargo.GetSearchObj(), index: this.gridrowindex, colindex: this.gridcolindex },that.pageset[0], true);
			} else {
				if (this.$refs.selectcargo.checkedrow.length > 0) this.addcargorow(this.$refs.selectcargo.checkedrow,that.pageset[0], true);
			}
		},
		addrow(e){
			this.addcargorow(e.rows,undefined,e.isclose);
		},
		//填写行
		addcargorow(rows,i, isclose) {
			var isset=false;
			if (isclose == undefined) isclose = false;
			var that = this;
			var rowindex = this.gridrowindex;
			if(i!=undefined){
				//判断新添加的商品是否已存在在已添加列表中，有则累加数量，没有则新增行
				i.cargolist.forEach(e => {
					var index = 0;
					rows.forEach(r => {
						if (r.id == e.id && e.id != '') {
							e.num = parseInt(e.num) + 1;
							//移除此行
							rows.splice(index, 1);
						}
						index++;
					});
				});
				rows.forEach(e => {
					if (rowindex > that.gridrowindex) i.cargolist.splice(rowindex, 0, JSON.parse(JSON.stringify(this.cargorow)));
					for (var key in i.cargolist[rowindex]) {
						for (var cargokey in e) {
							if (cargokey == key) {
								i.cargolist[rowindex][key] = e[key];
								break;
							}
						}
						if (key == 'num'&&i.cargolist[rowindex][key]=='') i.cargolist[rowindex][key] = '1';
					}
					rowindex++;
				});
			}
			else{
				that.pageset.forEach(p=>{
					p.setlist.forEach(s=>{
						if(s.controltype=='table')
						{
							s.cargolist.forEach(e => {
								var index = 0;
								rows.forEach(r => {
									if (r.id == e.id && e.id != '') {
										e.num = parseInt(e.num) + 1;
										//移除此行
										rows.splice(index, 1);
									}
									index++;
								});
							});
							rows.forEach(e => {
								if (rowindex > that.gridrowindex) s.cargolist.splice(rowindex, 0, JSON.parse(JSON.stringify(that.cargorow)));
								for (var key in s.cargolist[rowindex]) {
									for (var cargokey in e) {
										if (cargokey == key) {
											s.cargolist[rowindex][key] = e[key];
											break;
										}
									}
									if (key == 'num'&&s.cargolist[rowindex][key]=='') s.cargolist[rowindex][key] = '1';
								}
								rowindex++;
							});
							isset=true;
							return false;
						}
					});
					if(isset)
						return false;
				});
			}
			if (isclose) this.closecargo();
			else {
				if (rows.length > 0) {
					this.$refs.cargo[0].setfoucsbyindex(this.gridrowindex, undefined, 'num');
				}
			}
			this.$emit('addedcallback', {
				gridrowindex:this.gridrowindex
			});
		},
		//关闭选择商品
		closecargo() {
			var that=this;
			var isset=false;
			that.pageset.forEach(p=>{
				p.setlist.forEach(s=>{
					if(s.controltype=='table')
					{
						if (s.cargolist[that.gridrowindex].id != undefined) this.$refs.cargo[0].setfoucsbyindex(that.gridrowindex, undefined, 'num');
						isset=true;
						return false;
					}
				});
				if(isset)
					return false;
			});
			
		},
		//删除行
		deleteRow(e, i, index) {
			i.cargolist.splice(e.index, 1);
			if (i.cargolist.length < 1) {
				i.cargolist.push(JSON.parse(JSON.stringify(this.cargorow)));
			}
		},
		selectcargolist(){
			//
			this.$refs.selectcargo.init({searchparam:'1'});
		},
		enterinput(event, i, modelindex) {
			//console.log(val);
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if (i.colnext == 'tablegrid') this.$refs.cargo[0].setgridfoucs();
						else this.$refs[i.colnext][0].focus();
					}
				} else if (event.keyCode == 37) {
					if (i.colperv != '') this.$refs[i.colperv][0].focus();
				}
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		setuparrow() {
			this.enterinput({ keyCode: 37 }, { colperv: 'p_bagid' }, '');
		},
		setvalue(data,value){
			//debugger
			this._data[data]=value;
		},
		selectFilter(e){
			//debugger
			if(e.col.validate=='shelves'){
				this.$apipost.get.dic({ type: '货架',value:e.val }).then(res => {
					if (res != '') {
						e.col.source = res.list;
					}
				});
			}
		},
		clearlist(){
			var that=this;
			that.pageset[0].setlist.forEach(s => {
				var cargolist=JSON.parse(JSON.stringify(s.cargolist));
				cargolist.forEach(e=>{
					s.cargolist.splice(0, 1);
				});
				s.cargolist.push(JSON.parse(JSON.stringify(that.cargorow)));
			});
		},
		openselectcargo(){
			var that=this;
			this.$apipost.get.GetLinkInfo({ l_id:571 }).then(res => {
				//debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin.init({item:paramitem,title:'选择货品'});
				} else that.$tool.message('此功能无法启用', 0);
			});
		},
		//弹窗里面点击确定时调用的事件
		dialogsrue(e){
			//debugger
			//读取商品
			if(e.rows!=undefined)
				this.getsupplierprice(e.rows);
		},
		getsupplierprice(row){
			var that=this;
			var paraminfo={
				list:row,
				supplier:this.supplier,
				token:localStorage.getItem('token'),
				domain:this.$apiprototype.WebServer
			}
			this.$apipost.get.GetSupplierCargoPrice({paraminfo:paraminfo}).then(res => {
				//debugger
				if(res.state=='1')
					that.addcargorow(res.list,undefined);
				else
					that.addcargorow(row,undefined);
			});
		},
		gridchange(e){
			debugger
			var that=this;
			if(e.colindex!=undefined){
				if(this.columns[e.colindex].event=='setpackagenum'){
					this.setpackagenum(e.row);
				}
			}
		},
		setpackagenum(e){
			debugger
			if(e.num1!=undefined&&e.num1!=''&&e.unit1!=undefined&&e.unit1!=''){
				if(e.p_content!=''&&e.p_content!=undefined){
					var morespec=JSON.parse(e.p_content);
					morespec.forEach(b=>{
						if(b.unit==e.unit1){
							if(e.num1!=undefined){
								e.num=(Number(e.num1)*Number(b.num)).toString();
							}
							return false;
						}
					});
				}
			}
		}
	}
};
</script>

<style></style>
